import Vue from 'vue'

// import './components/main'
import './styles/base.scss'
import './components/primevue'

import { createPinia, PiniaVuePlugin } from 'pinia'
import servidor from './router/servidor'
//import vazio from './router/vazio.js'

import App from './App.vue'
import auth from './plugins/auth'
import html from './plugins/html'
import http from './plugins/http'
import i18n from './i18n'

import authentication from './plugins/authentication'
import authModule from '@/modules/auth'
import {
  applyKeycloakSession,
  clearAuthorizationCodeFromUrl,
  exchangeAuthorizationCode,
  getAuthorizationCode,
  getRedirectUri,
  getSsoErrorMessage,
} from '@/modules/sso'

export const bus = new Vue()

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(auth)
Vue.use(http)
Vue.use(html)
Vue.use(PiniaVuePlugin)
Vue.use(require('vue-moment'))

const pinia = createPinia()
const host = window.location.host
const parts = host.split('.')
const router = () => {
  let routes
  switch (parts[0]) {
    case 'servidor':
      routes = servidor
      break
    default:
      routes = servidor
      break
  }
  return routes
}

Vue.use(authentication)

async function handleAuthorizationCode() {
  const code = getAuthorizationCode()
  if (!code) {
    return
  }

  const redirectUri = getRedirectUri()
  const tokenResponse = await exchangeAuthorizationCode(code, redirectUri)

  authModule.token = tokenResponse.access_token
  authModule.refresh_token = tokenResponse.refresh_token
  authModule.expires_in = tokenResponse.expires_in
  applyKeycloakSession(Vue.$keycloak, tokenResponse)
  clearAuthorizationCodeFromUrl()
}

function mountApp() {
  setInterval(async () => {
    if (authModule.refresh_token != null && authModule.isAuthenticated()) {
      authModule.updateToken(
        window.location.origin + window.location.pathname,
        function () {},
      )
    }
  }, 50000)

  new Vue({
    router: router(),
    i18n,
    pinia,
    render: (h) => h(App),
  }).$mount('#app')
}

async function bootstrap() {
  try {
    await handleAuthorizationCode()
  } catch (error) {
    clearAuthorizationCodeFromUrl()
    console.warn(
      'Falha ao processar retorno do SSO:',
      getSsoErrorMessage(error),
    )
  }

  Vue.$keycloak
    .init({ checkLoginIframe: false })
    .catch((error) => {
      console.warn('Keycloak init:', error)
    })
    .finally(() => {
      mountApp()
    })
}

bootstrap()
